import {SpriteIconsType} from "@components/SpriteIcon";

export enum SocialProofType {
  MostPopular = "most_popular",
  MostFavorite = "most_favorited",
  HighestRating = "highest_rated",
}

export type SocialProofDetailsItem = {
  icon: SpriteIconsType;
  name: string;
  description: string;
  longDescription: string;
};

export interface SocialProofContextType {
  socialProofs?: {[key: number]: SocialProofType};
  getSocialProofDetails: (
    itemId: number,
    companyName?: string
  ) => SocialProofDetailsItem | null;
}
